import { render, staticRenderFns } from "./FoMarkdownNote.vue?vue&type=template&id=1cb338a5&scoped=true&"
import script from "./FoMarkdownNote.vue?vue&type=script&lang=js&"
export * from "./FoMarkdownNote.vue?vue&type=script&lang=js&"
import style0 from "./FoMarkdownNote.vue?vue&type=style&index=0&id=1cb338a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb338a5",
  null
  
)

component.options.__file = "FoMarkdownNote.vue"
export default component.exports